import { useEffect, useState } from 'react'
import { client } from '../lib/sanity'
import { Author } from '../types/sanity'
import { Link } from 'react-router-dom'
import { urlFor } from '../lib/sanity'

export default function AuthorsList() {
  const [authors, setAuthors] = useState<Author[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const query = `*[_type == "author"] | order(name asc) {
      _id,
      name,
      slug,
      image,
      bio
    }`

    client.fetch(query)
      .then((data: Author[]) => {
        if (!data || !Array.isArray(data)) {
          console.error('Invalid data format:', data)
          setError('Invalid data format received')
          setLoading(false)
          return
        }
        setAuthors(data)
        setLoading(false)
      })
      .catch((err) => {
        console.error('Error fetching authors:', err)
        setError(err.message || 'Error fetching authors')
        setLoading(false)
      })
  }, [])

  if (error) {
    return (
      <div className="w-screen flex justify-center mt-32">
        <div className="w-full max-w-[1280px] px-8">
          <h2 className="headline-large mb-12">Nuestros Autores</h2>
          <div className="text-center py-8 text-red-600 bg-white rounded-lg p-6">
            Error loading authors: {error}
          </div>
        </div>
      </div>
    )
  }

  if (loading) {
    return (
      <div className="w-screen flex justify-center mt-32">
        <div className="w-full max-w-[1280px] px-8">
          <h2 className="headline-large mb-12">Nuestros Autores</h2>
          <div className="text-center py-8 bg-white rounded-lg p-6">
            Loading authors...
          </div>
        </div>
      </div>
    )
  }

  if (!authors || authors.length === 0) {
    return (
      <div className="w-screen flex justify-center mt-32">
        <div className="w-full max-w-[1280px] px-8">
          <h2 className="headline-large mb-12">Nuestros Autores</h2>
          <div className="text-center py-8 bg-white rounded-lg p-6">
            No authors found. Check back soon!
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="w-screen flex justify-center mt-32 mb-32">
      <div className="w-full max-w-[1280px] px-8">
        <h2 className="headline-large mb-12">Nuestros Autores</h2>
        <div className="rounded-lg divide-y divide-gray-200">
          {authors.map((author) => (
            <Link 
              key={author._id}
              to={`/autor/${author.slug.current}`}
              className="block no-underline transition-all duration-300 hover:bg-white hover:shadow-sm rounded-lg"
            >
              <div className="p-6 flex items-center gap-6">
                <div className="w-20 h-20 rounded-full overflow-hidden flex-shrink-0">
                  {author.image ? (
                    <img
                      src={urlFor(author.image).width(200).height(200).url()}
                      alt={author.name}
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <div className="w-full h-full bg-gray-200 flex items-center justify-center">
                      <span className="text-gray-400 text-2xl">📸</span>
                    </div>
                  )}
                </div>
                <div className="flex-grow">
                  <h3 className="headline-small mb-1 text-gray-900">{author.name}</h3>
                  <p className="body-small text-gray-600 line-clamp-2">
                    {author.bio || 'No bio available'}
                  </p>
                </div>
                <div 
                  className="flex-shrink-0 px-6 py-2 bg-primary text-white rounded-full group-hover:bg-primary/90 transition-colors duration-300"
                >
                  Ver Posts
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  )
} 